<template>
  <div class="field">
    <label class="label">Message</label>
    <div class="control">
      <textarea
        class="textarea is-fullwidth"
        type="text"
        placeholder="Message"
        v-model="message"
        @focusout="handleChange"
      ></textarea>
      <div class="m-0 mt-1 p-0 is-size-7">{{ lengthLimit }} / {{ value.length }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PositionMessage',
  props: {
    value: {
      type: [String],
      required: true
    },
    positionId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      lengthLimit: 500,
      message: ''
    }
  },
  created () {
    this.message = this.value
  },
  watch: {
    value (value) { this.message = value },
    message (newVal, oldVal) {
      if (newVal.length > this.lengthLimit) {
        this.message = oldVal
      }
      this.$emit('input', this.message)
    }
  },
  methods: {
    async handleChange () {
      try {
        await this.$network_utils.updatePosition({ position_id: this.positionId, message: this.message, active_at: new Date() })
        this.$utils.emit('show_toast', { text: 'Success' })
      } catch (e) {
        this.$utils.emit('show_toast', { text: 'failed' })
      }
    }
  }
}
</script>
